import { FETCH_CHANGESHIFT } from './actionType'

const initialState = {
    changeshift: {},
  // profileData: {},
  // userLocation: DEFAULT_DATA
}
const changeshiftReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_CHANGESHIFT:
      return {
        ...state,
        changeshift: action.payload,
      }
    // case USER_PROFILE:
    //     return {
    //         ...state,
    //         profileData: action.payload
    //     };
    // case USER_LOCATION:
    //     return {
    //         ...state,
    //         userLocation: action.payload
    //     };
    default:
      return state
  }
}

export default changeshiftReducer
